module.exports = __webpack_public_path__ + "img/03.95f416d3.jpg";